import ScrollReveal from 'scrollreveal';

// In each section, allow to add up to 3 blocks to appear via:
//
// `.sequence-INDEX` (INDEX should be either 0, 1, or 2)
//
// Then add the following options in `<section>`
//
// `= section_tag(slice, html_opts: {class: 'animation', data: {'animation-distance': '2px', 'animation-interval': 100, 'animation-duration': 500, 'animation-delay': 0}})`
//
// Default values are:
// ```
// var opts = {
//   delay: section.dataset.animationDelay || 0,
//   duration: section.dataset.animationDuration || 500,
//   interval: section.dataset.animationInterval || 100,
//   distance: section.dataset.animationDistance || '2px'
// }
// ```
//
// delay is the time before reveal animations begin.
// distance controls how far elements move when revealed.
// duration controls how long animations take to complete.
// interval is the time between each reveal.

export const animateSections = () => {
  document.querySelectorAll('section.animation').forEach(function (section) {
    const delay = parseInt(section.dataset.animationDelay);
    const duration = parseInt(section.dataset.animationDuration);
    const interval = parseInt(section.dataset.animationInterval);
    const opts = {
      mobile: false,
      viewOffset: {
        top: 60
      },
      viewFactor: 0.3,
      delay: delay || 0,
      duration: duration || 500,
      interval: interval || 0,
      distance: section.dataset.animationDistance || '2px'
    };

    // later on would be a loop to have as many sequences as we want via data-sequence='x'
    if (section.querySelectorAll('.animation').length <= 3) {
      const animationArray = [
        section.querySelector('.sequence-0'),
        section.querySelector('.sequence-1'),
        section.querySelector('.sequence-2')
      ];

      ScrollReveal().reveal(animationArray, opts);
    } else {
      const animationArray = [
        section.querySelectorAll('.sequence-0'),
        section.querySelectorAll('.sequence-1'),
        section.querySelectorAll('.sequence-2')
      ];

      animationArray.forEach(function (nodeList) {
        ScrollReveal().reveal(nodeList, opts);
      });
    }
  });
};

// FIXME: QUICKFIX - CANCEL ANIMATION ON PRICING/PENTA PAGE BEFORE FIXING.
if (!window.location.pathname.includes('/pricing') && !window.location.pathname.includes('/penta') && !window.location.pathname.includes('/de/open-an-account')) {
  animateSections();
}
